"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Subject_1 = require("rxjs/internal/Subject");
var http_1 = require("./http");
var use_rx_effect_1 = require("./use-rx-effect");
function useReqRes(api$) {
    var req$ = new Subject_1.Subject();
    var res$ = req$.pipe(http_1.http(api$));
    return [res$, req$.next.bind(req$)];
}
/**
 * `useRxAjax`
 *
 * Executes data api calls and returns response and request dispatcher.
 * Optionally a callback function can be provided to react on response.
 *
 * Example:
 * const [response, dispatch] = useRxAjax(api.getSomething);
 *
 * @param api$ - Data API callback `(req: Req) => Observable<Res>`.
 * @param next - (optional) callback to be called when Response status is changed.
 */
function useRxAjax(api$, next) {
    var _a = react_1.useMemo(function () { return useReqRes(api$); }, [api$]), res$ = _a[0], submitReq = _a[1];
    var _b = react_1.useState(), res = _b[0], setRes = _b[1];
    use_rx_effect_1.useRxEffect(res$, function (nextRes) {
        setRes(nextRes);
        if (next) {
            next(nextRes);
        }
    });
    return [res, submitReq];
}
exports.useRxAjax = useRxAjax;
//# sourceMappingURL=use-rx-ajax.js.map